const TableHeaders=[
    {
        id: "1",
        header: "No.",
    },
    {
        id: "2",
        header: "Drug Name",
    },
    {
        id: "3",
        header: "Beer’s Criteria",
    },
    {
        id: "4",
        header: "STOPP",
    },
    {
        id: "5",
        header: "FORTA",
    },
];
export default TableHeaders;